export const isVideo = mediaType => mediaType?.toUpperCase() === 'VIDEO'

export const getFileName = fileUrl => {
  if (!fileUrl) return ''
  const parts = fileUrl.split('/')
  return parts[parts.length - 1] || ''
}

export const formatCustomerDisplayDate = value => {
  if (!value) return '—'
  return new Date(value).toLocaleDateString('es-NI')
}

export const buildCustomerDisplaySearchPayload = ({
  startDate,
  endDate,
  pagination,
  selectedCompany,
  selectedBranchOffice,
  selectedMediaType,
  searchText,
}) => {
  const payload = {
    PageNumber: pagination.currentPage,
    PageSize: pagination.pageSize,
  }

  if (startDate) payload.StartDate = startDate
  if (endDate) payload.EndDate = endDate
  if (selectedCompany) payload.CompanyId = selectedCompany
  if (selectedBranchOffice) payload.BranchOfficeId = selectedBranchOffice
  if (selectedMediaType) payload.MediaType = selectedMediaType
  if (searchText) payload.SearchText = searchText

  return payload
}

export const mapCustomerDisplayUpdatePayload = (item, status) => [
  {
    CustomerDisplaySettingId: item.CustomerDisplaySettingId,
    Name: item.Name,
    MediaType: item.MediaType,
    FileUrl: item.FileUrl,
    DisplayOrder: item.DisplayOrder,
    StartDate: item.StartDate,
    EndDate: item.EndDate,
    BranchOfficeId: item.BranchOfficeId,
    CompanyId: item.CompanyId,
    Status: status,
  },
]
